var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuPost(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5378_1688)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 35.5,
    fill: "#161618"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5625 52H26.4375C21.7851 52 18 48.4953 18 44.1875V34.8125C18 30.5047 21.7851 27 26.4375 27H36.5625C41.2149 27 45 30.5047 45 34.8125V44.1875C45 48.4953 41.2149 52 36.5625 52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6875 19H48.3125C50.8972 19 53 20.9626 53 23.375V28.625C53 31.0374 50.8972 33 48.3125 33C47.7941 33 47.375 32.608 47.375 32.125V30.375C47.375 26.9975 44.4303 24.25 40.8125 24.25H38.9375C38.4191 24.25 38 23.858 38 23.375C38 20.9626 40.1028 19 42.6875 19Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5378_1688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPost);
export default __webpack_public_path__ + "static/media/menu-post.46e5e9816ca9c4e24911919edea18ed6.svg";
export { ForwardRef as ReactComponent };